var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopupPicker = function SvgPopupPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12L8 5Q6 7 4 5z"
  })));
};
export default SvgPopupPicker;